import { createContext, useContext, type ReactNode } from "react";
import type { Me } from "./types";
import { useCurrentTenant } from "./currentTenant";

type AuthValue = {
  me: Me | null;
  refetchMe: () => Promise<void>;
  onLoggedOut: () => void;
};

const AuthContext = createContext<AuthValue | null>(null);

export function AuthProvider({ value, children }: { value: AuthValue; children: ReactNode }) {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}

/**
 * Returns the tenant id whose data the current dash view should show.
 * Reads from CurrentTenantContext so that impersonation, own-tenant
 * fallback, and all resolution rules live in exactly one place
 * (DashLayout). Must be called inside a DashLayout subtree.
 */
export function useTenantId(): string {
  return useCurrentTenant().id;
}
